// src/App.js - Enhanced with Firebase Integration

// Import the Firebase-enhanced version
import AppWithFirebase from './AppWithFirebase';

// Export the Firebase-enhanced version
export default AppWithFirebase;

/*
To use the original version without Firebase:
1. Rename this file to AppOriginal.js
2. Create a new App.js that imports and exports the original component
3. Or simply replace the import above with the original App component

For Firebase setup:
1. Update src/firebase/config.js with your Firebase project credentials
2. Enable Authentication and Firestore in your Firebase console
3. Set up authentication providers (Email/Password and Google)
*/